import { buildAPIActions } from '../utils/actions';

// build all available API actions
const Activities= buildAPIActions('activities');

export default Activities;
